import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CustomButton from "../components/CustomButton";

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Box
      style={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          style={{
            fontSize: 50,
            color: theme.palette.main.primary.o,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          404
        </Typography>
        <Typography
          style={{
            marginBottom: 36,
            fontSize: 16,
            fontWeight: "400",
            color: theme.palette.natural.t1,
          }}
        >
          {t("notFound.title")}
        </Typography>
        <CustomButton
          style={{ width: 68 }}
          size='medium'
          title={t("notFound.back")}
          onClick={() => navigate(-1)}
        />
      </Box>
    </Box>
  );
};

export default NotFound;
